import React from 'react';
import { ReactSVG } from 'react-svg';
import styled, { useTheme } from 'styled-components';
import { ICON_ROOT_PATH, SizeRecord, getIconColor, } from './Icon.utils';
const StyledIcon = styled(ReactSVG) `
  div {
    display: flex;
    align-items: center;
  }
  svg {
    height: ${({ size }) => SizeRecord[size]}px;
    width: ${({ size }) => SizeRecord[size]}px;
  }
`;
const Icon = ({ name, color = 'gray-100', size = 'medium', }) => {
    const theme = useTheme();
    const src = `${ICON_ROOT_PATH}/${name}.svg`;
    // Some weird type issue with ReactSVG & styled-components happens here so we need to ignore it
    return (
    // @ts-ignore
    React.createElement(StyledIcon
    // @ts-ignore
    , { 
        // @ts-ignore
        src: src, size: size, className: "ReactIcon-root", 
        // @ts-ignore
        beforeInjection: (svg) => {
            svg.setAttribute('color', getIconColor(color, theme));
        } }));
};
export default Icon;
